import * as React from 'react';

import Reports from '../../components/Reports/Reports';

export default function ReportsPage(): React.JSX.Element {
    return <Reports/>;
}
